export var uuid = function (prefix) {
    if (prefix === void 0) { prefix = ''; }
    return prefix + "uuid-" + Math.random().toString(36).substr(2, 16);
};
